import { Transaction } from '@/types/crypto';
import { getTransactionStateDisplayValue, getTransactionTypeDisplayValue } from '@/shared/helpers/transactions';
import { getAssetName } from '@/shared/helpers/assets';
import React, { useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import Icon from '@/shared/components/Icon/Icon';
import styles from '@/shared/components/TransactionListControl/TransactionListControl.module.css';
import { IonButton } from '@ionic/react';
import { useTransactions } from '@/shared/hooks/transactions';
import { getShortDateTimeString } from '@/shared/helpers/formatters';
import { useTranslation } from 'react-i18next';

const getCsvTransaction = (transaction: Transaction) => {
  return {
    id: transaction.uuid,
    transactionType: getTransactionTypeDisplayValue(transaction.transactionType),
    assetId: getAssetName(transaction.assetId),
    amount: transaction.amount,
    sourceAddress: transaction.sourceAddress,
    sourceTag: transaction.sourceTag,
    targetAddress: transaction.targetAddress,
    destinationTag: transaction.destinationTag,
    createdAt: getShortDateTimeString(transaction.createdAt),
    finalizedAt: getShortDateTimeString(transaction.finalizedAt),
    transactionState: getTransactionStateDisplayValue(transaction.transactionState)
  };
};

const CSVDownload = (props) => {
  const btnRef = useRef(null);

  // @ts-ignore
  useEffect(() => btnRef.current?.click(), [btnRef]);

  return (
    <CSVLink {...props}>
      <span ref={btnRef} />
    </CSVLink>
  );
};

const CsvDownloadButton: React.FC = () => {
  const { t } = useTranslation();

  const { transactions, isLoading } = useTransactions();
  const [initiateDownload, setInitiateDownload] = useState<boolean>(false);

  const handleCsvDownload = async () => {
    if (!isLoading) {
      setInitiateDownload(true);
    }
  };

  useEffect(() => {
    setInitiateDownload(false);
  }, [initiateDownload]);

  const csvHeaders = [
    { key: 'id', label: t('transactions.csv.id') },
    { key: 'transactionType', label: t('transactions.csv.transaction_type') },
    { key: 'assetId', label: t('transactions.csv.crypto_currency') },
    { key: 'amount', label: t('transactions.csv.amount') },
    { key: 'sourceAddress', label: t('transactions.csv.source_address') },
    { key: 'sourceTag', label: t('transactions.csv.source_address_tag') },
    { key: 'targetAddress', label: t('transactions.csv.target_address') },
    { key: 'destinationTag', label: t('transactions.csv.target_address_tag') },
    { key: 'createdAt', label: t('transactions.csv.created_at') },
    { key: 'finalizedAt', label: t('transactions.csv.finalized_at') },
    { key: 'transactionState', label: t('transactions.csv.transaction_state') }
  ];

  return (
    <>
      <IonButton
        onClick={handleCsvDownload}
        disabled={isLoading}
        size="small"
        shape="round"
        className="ion-float-right"
      >
        Download
        <Icon
          src="assets/icons/cloud-download-outline.svg"
          slot="end"
          size="medium"
          className={styles.icon}
          color="white"
        />
      </IonButton>
      {initiateDownload && (
        <CSVDownload
          target="_blank"
          filename="Transaktionen"
          headers={csvHeaders}
          separator=";"
          data={transactions?.map(getCsvTransaction) || []}
        />
      )}
    </>
  );
};

export default CsvDownloadButton;
